import React, { PureComponent } from 'react';
import _ from 'lodash';

// Components
import { Spin, Modal, Table, Button, Icon } from 'antd';
import Text from 'antd/es/typography/Text';

// Constants
import { MODAL_SIZES } from '../../../constants/modal';

class HubDetailsModal extends PureComponent {

    statusColor = (hubStatus) => {
        if (hubStatus) {
            return (hubStatus.status === "UP" || hubStatus.status === "INFO") ? "green" :
                ( (hubStatus.status === "STARTING" || hubStatus.status === "WARNING") ? "gold" : "red");
        }
        return "grey";
    }

    ageString = (hubStatus) => {
        if (hubStatus) {
            let age = (Date.now() - hubStatus.ts) / 1000;
            if (age < 0)
                age = 0;
            if (age < 60)
                return `${  Math.floor(age)  } sec `;
            age /= 60;
            if (age < 60)
                return `${  Math.floor(age)  } min `;
            age /= 60;
            if (age < 24)
                return `${  Math.floor(age)  } hours `;
            age /= 24;
            return `${  Math.floor(age)  } days `;
        }
        return "";
    }

    prepareForDisplay = (message) => {
        const messageForDisplay = {
            status: <Text style={{ color: this.statusColor(message) }}>{message.status}</Text>,
            age: this.ageString(message),
            message: this.splitText(message.message)
        }

        return messageForDisplay;
    }

    splitText = (message) => {
        const messageParts = message.split("\r\n");

        return <React.Fragment>
            {messageParts.map(element => 
                <>
                <Text>{element}</Text>
                <br />
                </>
            )}
        </React.Fragment>
        
    }

    render() {
        const {
            isShown,
            isLoading,
            msgs,
            onCancel,
            messages,
            hubName,
            onDelete
        } = this.props;

        const columns = [
            {
                title: msgs.homes.detail.status,
                dataIndex: 'status',
                key: 'status'
            },
            {
                title: msgs.homes.detail.age,
                dataIndex: 'age',
                key: 'age'
            },
            {
                title: msgs.homes.detail.message,
                dataIndex: 'message',
                key: 'message'
            }
        ];       

        const messagesSorted = _.orderBy(messages, ['ts'], ['desc']);

        return (
            <Modal
                key="modal-hub-details"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.LARGE}
                title={`${msgs.homes.detail.hubDetails} - ${hubName}`}
                onCancel={onCancel}
                cancelText={msgs.close}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <Spin spinning={isLoading} size="large">
                    <Button 
                        style={{ marginBottom: 10 }}
                        type="danger"
                        disabled={messages.length === 0}
                        onClick={onDelete}>
                            {msgs.homes.detail.deleteMessages}
                            <Icon type="delete" />
                    </Button>
                    <Table
                        
                        pagination={false}
                        dataSource={messagesSorted.map(message => this.prepareForDisplay(message))}
                        columns={columns}
                    />                  
                </Spin>
            </Modal>
        );
    }
}

export default HubDetailsModal;